import { ComponentPropsWithoutRef } from 'react';

export const CropIcon = ({ ...props }: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 30 30" fill="none">
      <path
        d="M7 1.002V21a2 2 0 0 0 2 2h19.999"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 7.002h20a2 2 0 0 1 1.999 2V29"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
